import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikFarbsensor extends ASTBlock {
    constructor(color) {
        super(color, "alvik_farbsensor")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "%1 Farbanteil des Bodensensors %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "color",
                    "options": [
                        [
                            "roter",
                            "0"
                        ],
                        [
                            "grüner",
                            "1"
                        ],
                        [
                            "blauer",
                            "2"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Boolean"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}